import React, { useEffect, useState } from 'react';
import { Header, Icon, Modal, Step, Loader, Dimmer } from 'semantic-ui-react';

import DocumentsComponent from '../Steps/DocumentsComponentStep';
import { Formik } from 'formik';
import { CreateClaimEstateInitialInfo } from '../Formik/InitialValues/CreateClaimEstateInitialInitialValues';
import ClaimEstateInfoStep from '../Steps/ClaimEstateInfoStep';
import ClaimValuesStep from '../Steps/ClaimValuesStep';
import {
  ClaimValueFormikType,
  CreateClaimEstateInitialInitialValuesType,
  CreateClaimValuesInitialValuesType
} from '../Formik/types/CreateClaimEstateInitialValuesTypes';
import {
  dangerNotification,
  successNotification,
  warningNotification
} from '../../../../../services/notification';
import { InsurerState } from '../../../../../types/InsurerState';
import { connect } from 'react-redux';
import { iRootDispatch, iRootState } from '../../../../../store';
import { AvailableBrokersAndEstatesState } from '../../../../../store/types/temp-types';
import { CustoDropDownItemProps } from '../../../../../components/types';
import { uuid } from 'uuidv4';
import { postFileAndGetPreSignAxios, getFilesLinkAxios, deleteFilesLinkAxios } from '../../../../../services/file';
import { createClaimEstate, udateClaimEstate, claimSubmitProps } from '../../../../../services/claims';
import { ClaimPropertyStatusEnum } from '../../../../../enums/claim-property-status.enum';
import { ClaimEstatesStatusEnum } from '../../../../../enums/claim-estate-status.enum';
import { FormatDateYMD, FormatDateYMD_UTC_IGNORE } from '../../../../../services/date';
import { useHistory } from 'react-router-dom';
import { translateValuesType } from '../../../util';
import ModalInstructions from '../../ModalInstructions';
import { InsurersCodeEnum } from '../../../../../enums/insurers-code.enum';
import { PolicyForGetBondInsurancePoliciesListResponseDTO } from '../../../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import { getFileIdentifiers } from '../utils';
import { Callback } from '../../../../../types/Calback';
import { get, set } from '../../../../../services/storage';
import { getClaims, getClaimByAddress } from '../../../../../services/claim';
import Button from '../../../../../components/Button';
import styled from 'styled-components';
import InitialVerifications from '../Steps/InitialVerifications';
import { maskCpfOrCnpj } from '../../../../../services/masks';
import { ClaimValuesTypesEnum } from '../../../enums/ClaimValues.enum';
import { extractApiErrorMessages } from '../../../../../utils/apiErrorHandler';
import { sanitizeFilename, validateFileAccessibility } from '../../../../../utils/fileUtils';

const StepWrapper = styled(Step)`
  .title {
    color: ${props => props.theme.main.color} !important;
  }
`;

type ModalContentType = {
  children: React.ReactNode;
  values: CreateClaimEstateInitialInitialValuesType;
};

const CreateClaimEstateModal = (props: {
  availableBrokersAndEstates: AvailableBrokersAndEstatesState;
  onlyModal?: boolean;
  policy?: PolicyForGetBondInsurancePoliciesListResponseDTO;
  onClose?: Callback;
  draftId?: string;
  cloneId?: string;
}) => {
  const { onlyModal = false, policy, onClose, draftId, cloneId } = props;
  const estates: CustoDropDownItemProps[] = props.availableBrokersAndEstates.estates;
  let insurers: InsurerState[] | null = props.availableBrokersAndEstates.insurers.map(
    (insurer: any) => insurer.value
  );
  if (insurers) {
    insurers = insurers.concat({
      id: '297c0ed6-a9ea-48d3-b0da-235597ae9f7a',
      name: 'Liberty Seguros',
      code: InsurersCodeEnum.Liberty
    } as InsurerState);
  }
  const [openHireProposalModal, setOpenHireProposalModal] = useState(false);
  const [stepOfHireModal, setStepOfHireModal] = useState('initial_verifications');
  const [registerId, setRegisterId] = useState('');
  const [existingFiles, setExistingFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [uploadProgress, setUploadProgress] = useState<{
    current: number;
    total: number;
    fileName: string;
  } | null>(null);
  const history = useHistory();
  const [claimAlread, setClaimAlread] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const toggleOpen = () => setOpenModal(true);
  const toggleClose = () => setOpenModal(false);

  const [selectedPolicy, setSelectedPolicy] = useState<any | null>(null);
  const [initialValues, setInitialValues] = useState<CreateClaimEstateInitialInitialValuesType>(
    CreateClaimEstateInitialInfo
  );

  const handleInitialVerificationsNext = (policy?: any) => {
    if (policy) {
      setSelectedPolicy(policy);
    }
    setStepOfHireModal('claim_estate_info');
  };

  useEffect(() => {
    if (onlyModal) {
      setOpenHireProposalModal(true);
    }
  }, [onlyModal]);

  useEffect(() => {
    if (draftId) {
      setRegisterId(draftId);
      setOpenHireProposalModal(true);
      fetchDraftData(draftId);
    } else if (cloneId) {
      // Clone creates a NEW claim with a new ID
      setRegisterId(uuid());
      setOpenHireProposalModal(true);
      fetchCloneData(cloneId);
    } else {
      setRegisterId(uuid());
      setInitialValues(CreateClaimEstateInitialInfo);
    }
  }, [draftId, cloneId]);

  async function fetchDraftData(id: string) {
    setLoading(true);
    try {
      const claimEstate = await getClaims({ id });
      const cv = claimEstate.claimValues.map((cv: any) => ({
        ...cv,
        dueDate: cv.dueDate ? new Date(cv.dueDate) : undefined
      }));


      // Determina se é imóvel desocupado para definir damageControl
      const isVacant = claimEstate.claimProperty?.status === ClaimPropertyStatusEnum.vacant;

      const payload: CreateClaimEstateInitialInitialValuesType = {
        claimEstate: {
          ...claimEstate,
          insurerId: claimEstate.insurer?.id,
          estateId: claimEstate.estate?.id,
          notificationEmails: claimEstate.notificationEmails ? claimEstate.notificationEmails.split(';') : [],
          // Garantir que campos de relacionamento sejam apenas IDs, não objetos
          policyId: claimEstate.bondInsuranceHiredData?.id || claimEstate.policyId || null,
          bondInsuranceHiredData: claimEstate.bondInsuranceHiredData?.id || null,
          responsibleId: claimEstate.responsible?.id || claimEstate.responsibleId || null,
        },
        claimTenant: {
          ...claimEstate.claimTenant,
          document: maskCpfOrCnpj(claimEstate.claimTenant?.document || '')
        },
        claimProperty: {
          ...claimEstate.claimProperty,
          status: claimEstate.claimProperty?.status || ClaimPropertyStatusEnum.occupied,
        },
        claimValues: {
          condominiumFee: cv.filter((c: any) => c.valueType === 'CONDOMINIUM_FEE'),
          energyBill: cv.filter((c: any) => c.valueType === 'ENERGY_BILL'),
          gasBill: cv.filter((c: any) => c.valueType === 'GAS_BILL'),
          paintingValue: cv.filter((c: any) => c.valueType === 'PAINTING_VALUE'),
          penalty: cv.filter((c: any) => c.valueType === 'PENALTY'),
          propertyDamageValue: cv.filter((c: any) => c.valueType === 'PROPERTY_DAMAGE_VALUE'),
          rentValue: cv.filter((c: any) => c.valueType === 'RENT_VALUE'),
          taxesValue: cv.filter((c: any) => c.valueType === 'TAXES_VALUE'),
          waterBill: cv.filter((c: any) => c.valueType === 'WATER_BILL'),
          fireInsuranceBill: cv.filter((c: any) => c.valueType === 'FIRE_INSURANCE_BILL'),
        },
        claimFiles: [],
        // Se imóvel desocupado e há valores de pintura ou danos, assume que damageControl é true
        damageControl: isVacant && (
          cv.some((c: any) => c.valueType === 'PAINTING_VALUE' && c.value > 0) ||
          cv.some((c: any) => c.valueType === 'PROPERTY_DAMAGE_VALUE' && c.value > 0)
        ),
        tenantType: claimEstate.claimTenant?.document ? (claimEstate.claimTenant.document.replace(/\D/g, '').length > 11 ? 'pj' : 'pf') : null
      };

      try {
        const filesResponse = await getFilesLinkAxios(id, 'CLAIM_ESTATES');
        if (filesResponse.urls) {
          setExistingFiles(filesResponse.urls.map((u: any) => ({
            id: u.id,
            key: u.name,
            name: u.name.split('/').pop(),
            url: u.link,
            option: u.name // Necessário para validação de arquivos obrigatórios
          })));
        }
      } catch (err) {
        console.log("Erro ao buscar arquivos do rascunho", err);
      }

      setInitialValues(payload);

      // Need to fill empty arrays if filtered result is empty to match Formik structure
      const valueTypes: (keyof CreateClaimValuesInitialValuesType)[] = ['condominiumFee', 'energyBill', 'gasBill', 'paintingValue', 'penalty', 'propertyDamageValue', 'rentValue', 'taxesValue', 'waterBill', 'fireInsuranceBill'];
      valueTypes.forEach(key => {
        if (payload.claimValues[key].length === 0) {
          payload.claimValues[key].push({ valueType: (key as string).replace(/([A-Z])/g, '_$1').toLowerCase(), value: 0 } as any);
        }
      });

      setInitialValues(payload);
    } catch (err) {
      console.error(err);
      dangerNotification('Erro', 'Erro ao carregar rascunho');
    } finally {
      setLoading(false);
    }
  }

  // Documents to be cloned from source claim
  const cloneDocumentKeys = [
    'LOCATION_QUOTATION',           // Contrato de locação
    'PROPERTY_MANAGEMENT_CONTRACT', // Contrato de administração
    'LETTER_ATTORNEY',              // Procuração
    'INITIAL_INSPECTION_PROPERTY',  // Vistoria inicial
    'FINAL_INSPECTION_PROPERTY'     // Vistoria final
  ];

  async function fetchCloneData(sourceClaimId: string) {
    setLoading(true);
    try {
      const claimEstate = await getClaims({ id: sourceClaimId });

      // Pre-fill initial_verifications and claim_estate_info data
      // BUT do NOT pre-fill claimValues (those remain empty for new claim)
      const payload: CreateClaimEstateInitialInitialValuesType = {
        claimEstate: {
          // Reset IDs and timestamps for new claim
          id: '',
          status: 'CREATED',
          createdAt: new Date(),
          createdBy: '',
          observations: '',
          responsibleId: null,
          policyNumber: null,
          processNumber: null,
          claimCode: null,
          // Copy these fields from source claim
          estateId: claimEstate.estate?.id || '',
          insurerId: claimEstate.insurer?.id || '',
          policyId: claimEstate.policyId,
          notificationEmails: claimEstate.notificationEmails ? claimEstate.notificationEmails.split(';') : [],
        },
        claimTenant: {
          // Copy tenant info
          document: maskCpfOrCnpj(claimEstate.claimTenant?.document || ''),
          fullName: claimEstate.claimTenant?.fullName || '',
          email: claimEstate.claimTenant?.email || '',
          cellphone: claimEstate.claimTenant?.cellphone || '',
        },
        claimProperty: {
          // Copy property info
          zipCode: claimEstate.claimProperty?.zipCode || '',
          street: claimEstate.claimProperty?.street || '',
          number: claimEstate.claimProperty?.number || '',
          complement: claimEstate.claimProperty?.complement || '',
          district: claimEstate.claimProperty?.district || '',
          city: claimEstate.claimProperty?.city || '',
          state: claimEstate.claimProperty?.state || '',
          country: claimEstate.claimProperty?.country || '',
          status: claimEstate.claimProperty?.status || ClaimPropertyStatusEnum.occupied,
          deliveryKeysDate: undefined, // Reset for new claim
        },
        // Initialize empty claimValues - these should NOT be copied
        claimValues: {
          condominiumFee: [{ valueType: ClaimValuesTypesEnum.condominium_fee, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          energyBill: [{ valueType: ClaimValuesTypesEnum.energy_bill, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          gasBill: [{ valueType: ClaimValuesTypesEnum.gas_bill, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          paintingValue: [{ valueType: ClaimValuesTypesEnum.painting_value, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          penalty: [{ valueType: ClaimValuesTypesEnum.penalty, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          propertyDamageValue: [{ valueType: ClaimValuesTypesEnum.property_damage_value, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          rentValue: [{ valueType: ClaimValuesTypesEnum.rent_value, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          taxesValue: [{ valueType: ClaimValuesTypesEnum.taxes_value, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          waterBill: [{ valueType: ClaimValuesTypesEnum.water_bill, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
          fireInsuranceBill: [{ valueType: ClaimValuesTypesEnum.fire_insurance_bill, value: undefined, dueDate: undefined, totalInstallments: undefined, numberInstallment: undefined }],
        },
        claimFiles: [],
        damageControl: false,
        tenantType: claimEstate.claimTenant?.document
          ? (claimEstate.claimTenant.document.replace(/\D/g, '').length > 11 ? 'pj' : 'pf')
          : null
      };

      // Fetch documents from source claim and filter only the ones we want to clone
      try {
        const filesResponse = await getFilesLinkAxios(sourceClaimId, 'CLAIM_ESTATES');
        if (filesResponse.urls) {
          const clonedFiles = filesResponse.urls
            .filter((u: any) => {
              // Extract the document type from the file name/key
              const fileName = u.name || '';
              return cloneDocumentKeys.some(key => fileName.includes(key));
            })
            .map((u: any) => ({
              id: u.id,
              key: u.name,
              name: u.name.split('/').pop(),
              url: u.link,
              option: u.name // Necessário para validação de arquivos obrigatórios
            }));
          setExistingFiles(clonedFiles);
        }
      } catch (err) {
        console.log("Erro ao buscar arquivos do sinistro original", err);
      }

      setInitialValues(payload);
    } catch (err) {
      console.error(err);
      dangerNotification('Erro', 'Erro ao carregar dados do sinistro para clonagem');
    } finally {
      setLoading(false);
    }
  }

  function handleCloseModal() {
    setOpenHireProposalModal(false);
    onClose && onClose();
  }

  function handleOpenModal() {
    setStepOfHireModal('initial_verifications');
    setOpenHireProposalModal(true);
  }

  function handleClaimAlread() {
    setClaimAlread(null);
  }

  async function handleDeleteExistingFile(id: string) {
    try {
      setLoading(true);
      await deleteFilesLinkAxios(id);
      setExistingFiles(prev => prev.filter(f => f.id !== id));
      successNotification('Sucesso', 'Arquivo removido com sucesso!');
    } catch (err) {
      dangerNotification('Erro', 'Erro ao remover arquivo.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  async function handleNextStep(values: CreateClaimEstateInitialInitialValuesType) {
    switch (stepOfHireModal) {
      case 'claim_estate_info': {
        let error = false;
        ///@ToDo Verficar se é broker, se for, obrigar informar o estateId. Se for imob, pegar do localstorage
        if (!values.claimEstate.estateId) {
          warningNotification('Ops...', 'Por favor, selecione a imobiliária desejada!');
          error = true;
        }

        if (
          !values.claimEstate.notificationEmails ||
          values.claimEstate.notificationEmails.length < 1 ||
          !values.claimEstate.notificationEmails[0]
        ) {
          warningNotification(
            'Ops...',
            'Por favor, insira pelo menos um email para notificação!'
          );
          error = true;
        }

        if (
          values.claimEstate.notificationEmails &&
          values.claimEstate.notificationEmails.length > 0
        ) {
          const emails = values.claimEstate.notificationEmails;
          // Regex que rejeita acentos e valida formato de email
          const emailRegex = /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
          for (let i = 0; i < emails.length; i++) {
            if (!emailRegex.test(emails[i]) && emails[i].length !== 0) {
              dangerNotification(
                'E-mail Adicional',
                "O campo E-mail Adicional '" +
                emails[i] +
                "' é inválido, verifique e tente novamente."
              );
              return;
            }
          }
        }

        if (!values.claimEstate.status) {
          warningNotification(
            'Ops...',
            'Por favor, informe se o imóvel está ocupado ou desocupado!'
          );
          error = true;
        }

        if (!values.claimTenant.document) {
          warningNotification('Ops...', 'Por favor, informe o DOCUMENTO do locatário!');
          error = true;
        }

        if (!values.claimTenant.fullName) {
          warningNotification(
            'Ops...',
            'Por favor, informe o NOME COMPLETO do locatário!'
          );
          error = true;
        }

        if (!values.claimTenant.cellphone) {
          warningNotification('Ops...', 'Por favor, informe o TELEFONE do locatário!');
          error = true;
        }

        if (!values.claimTenant.email) {
          warningNotification('Ops...', 'Por favor, informe o EMAIL do locatário!');
          error = true;
        }

        if (
          values.claimProperty.status === ClaimPropertyStatusEnum.vacant &&
          !values.claimProperty.deliveryKeysDate
        ) {
          warningNotification(
            'Ops...',
            'Por favor, informe a DATA DE ENTREGA DAS CHAVES!'
          );
          error = true;
        }

        if (!values.claimProperty.zipCode) {
          warningNotification('Ops...', 'Por favor, informe o CEP do imóvel!');
          error = true;
        }

        if (!values.claimProperty.state) {
          warningNotification('Ops...', 'Por favor, informe o ESTADO do imóvel!');
          error = true;
        }

        if (!values.claimProperty.city) {
          warningNotification('Ops...', 'Por favor, informe a CIDADE do imóvel!');
          error = true;
        }

        if (!values.claimProperty.district) {
          warningNotification('Ops...', 'Por favor, informe o BAIRRO do imóvel!');
          error = true;
        }

        if (!values.claimProperty.street) {
          warningNotification('Ops...', 'Por favor, informe o LOGRADOURO do imóvel!');
          error = true;
        }

        if (!values.claimProperty.number) {
          warningNotification('Ops...', 'Por favor, informe o NÚMERO do imóvel!');
          error = true;
        }

        if (!error) {
          try {
            setClaimAlread(null);
            const body = {
              zipCode: values.claimProperty.zipCode,
              street: values.claimProperty.street,
              district: values.claimProperty.district,
              state: values.claimProperty.state,
              city: values.claimProperty.city,
              number: values.claimProperty.number,
              complement: values.claimProperty.complement
                ? values.claimProperty.complement
                : ''
            };
            getClaimByAddress(body).then(result => {
              // API retorna { data: claim } ou { data: null }
              if (result?.data) {
                setClaimAlread(result.data);
              } else {
                setStepOfHireModal('claim_values_info');
              }
            }).catch(err => {
              // Se falhar a verificação, apenas loga e permite prosseguir
              console.error('Erro ao verificar endereço para sinistro:', err);
              setStepOfHireModal('claim_values_info');
            });
          } catch (err) {
            // Erro inesperado - loga e permite prosseguir
            console.error('Erro inesperado ao processar step claim_estate_info:', err);
            setStepOfHireModal('claim_values_info');
          }
        }
        return;
      }
      case 'claim_values_info': {
        let error = false;
        const claimValues = values.claimValues.condominiumFee
          .concat(values.claimValues.energyBill)
          .concat(values.claimValues.gasBill)
          .concat(values.claimValues.paintingValue)
          .concat(values.claimValues.penalty)
          .concat(values.claimValues.propertyDamageValue)
          .concat(values.claimValues.rentValue)
          .concat(values.claimValues.taxesValue)
          .concat(values.claimValues.waterBill)
          .concat(values.claimValues.fireInsuranceBill);
        const cv = [];
        claimValues.forEach(e => {
          if (e.value && e.valueType) {
            if (!e.dueDate) {
              warningNotification(
                'Ops...',
                `Favor informar a data de vencimento de ${translateValuesType(
                  e.valueType
                )}`
              );
              error = true;
            }
            if (e.value <= 0) {
              warningNotification(
                'Ops...',
                `Valor de ${translateValuesType(e.valueType)}; Deve ser maior que Zero`
              );
              error = true;
            }
            if (e.value && e.valueType && e.dueDate) {
              cv.push(e);
            }
          }
        });

        if (cv.length < 1) {
          warningNotification(
            'Ops...',
            'Por favor, informe pelo menos um valor para abertura do sinistro!'
          );
          error = true;
        }
        if (!error) {
          setStepOfHireModal('document_attachment');
        }
        return;
      }
      case 'document_attachment': {
        const fileIdentifiers =
          values.claimProperty.status === ClaimPropertyStatusEnum.occupied
            ? [
              { name: 'Boleto Aluguel', key: 'RENT_BILL', required: true },
              {
                name: 'Boleto Condomínio',
                key: 'CONDOMINIUM_BILL',
                required: false
              },
              {
                name: 'Guia de IPTU',
                key: 'IPTU_GUIDE',
                required: false
              },
              {
                name: 'Vistoria Inicial do Imóvel',
                key: 'INITIAL_INSPECTION_PROPERTY',
                required: false
              },
              {
                name: 'RG do Locador',
                key: 'LOCATOR_DOCUMENT',
                required: false
              },
              {
                name: 'Comprovante de Endereço Locador',
                key: 'LOCATOR_ADDRESS_DOCUMENT',
                required: false
              },
              {
                name: 'RG/CPF do Locatário',
                key: 'TENANT_DOCUMENT',
                required: false
              },
              {
                name: 'Contrato Garantti Locatário',
                key: 'LOCATOR_GARANTTI_CONTRACT',
                required:
                  values.claimEstate.insurerId && insurers
                    ? insurers
                      .find(c => c.id === values.claimEstate.insurerId)
                      ?.code.includes(InsurersCodeEnum.Garantti)
                      ? true
                      : false
                    : false
              },
              {
                name: 'Imissão na posse',
                key: 'POSSESSION_IMMISSION',
                required: false
              },
              {
                name: 'Acordo escritório',
                key: 'OFFICE_AGREEMENT',
                required: false
              },
              {
                name: 'Apólice Seguro Incêndio',
                key: 'FIRE_INSURANCE_POLICY',
                required: false
              },
              {
                name: 'Comprovante de Pagamento (planilha)',
                key: 'PAYMENT_VOUCHER',
                required: false
              },
              {
                name: 'Contrato de administração',
                key: 'PROPERTY_MANAGEMENT_CONTRACT',
                required: true
              },
              {
                name: 'Procuração',
                key: 'LETTER_ATTORNEY',
                required: true
              },
              {
                name: 'Declaração de débitos',
                key: 'DEBITS_SHEET',
                required: true
              },
              {
                name: 'Acordo de Confissão de Dívidas',
                key: 'DEBT_CONFESS_AGREEMENT',
                required: false
              },
              {
                name: 'Contrato de Locação',
                key: 'LOCATION_QUOTATION',
                required: true
              },
              {
                name: 'Planilha de indenização',
                key: 'INDEMNITY_WORKSHEET',
                required: false
              },
              {
                name: 'Planilha de acordo',
                key: 'ACCORD_WORKSHEET',
                required: false
              },
              {
                name: 'Água',
                key: 'WATER_BILL',
                required: false
              },
              {
                name: 'Luz',
                key: 'ENERGY_BILL',
                required: false
              },
              {
                name: 'Apólice Seguro Fiança',
                key: 'BAIL_INSURANCE_POLICY',
                required: false
              },
              {
                name: 'Boleto Devolutivo',
                key: 'RETURN_BILL',
                required: false
              },
              {
                name: 'Planilha de danos',
                key: 'DAMAGE_WORKSHEET',
                required: false
              },
              {
                name: 'Planilha de pintura',
                key: 'PAINTING_WORKSHEET',
                required: false
              },
              {
                name: 'Informativo de sinistro',
                key: 'CLAIM_INFORMATION',
                required: false
              },
              { name: 'Outros', key: 'OTHER', required: false }
            ]
            : [
              { name: 'Boleto Aluguel', key: 'RENT_BILL', required: true },
              {
                name: 'Boleto Condomínio',
                key: 'CONDOMINIUM_BILL',
                required: false
              },
              {
                name: 'Guia de IPTU',
                key: 'IPTU_GUIDE',
                required: false
              },
              {
                name: 'Vistoria Inicial do Imóvel',
                key: 'INITIAL_INSPECTION_PROPERTY',
                required: values.damageControl
              },
              {
                name: 'Vistoria Final do Imóvel',
                key: 'FINAL_INSPECTION_PROPERTY',
                required: values.damageControl
              },
              { name: 'Orçamentos', key: 'BUDGETS', required: values.damageControl },
              {
                name: 'Termo de entrega das chaves',
                key: 'TERM_DELIVERY_PROPERTY_KEYS',
                required: true
              },
              {
                name: 'RG do Locador',
                key: 'LOCATOR_DOCUMENT',
                required: false
              },
              {
                name: 'Comprovante de Endereço Locador',
                key: 'LOCATOR_ADDRESS_DOCUMENT',
                required: false
              },
              {
                name: 'RG/CPF do Locatário',
                key: 'TENANT_DOCUMENT',
                required: false
              },
              {
                name: 'Contrato Garantti Locatário',
                key: 'LOCATOR_GARANTTI_CONTRACT',
                required:
                  values.claimEstate.insurerId && insurers
                    ? insurers
                      .find(c => c.id === values.claimEstate.insurerId)
                      ?.code.includes(InsurersCodeEnum.Garantti)
                      ? true
                      : false
                    : false
              },
              {
                name: 'Imissão na posse',
                key: 'POSSESSION_IMMISSION',
                required: false
              },
              {
                name: 'Acordo escritório',
                key: 'OFFICE_AGREEMENT',
                required: false
              },
              {
                name: 'Apólice Seguro Incêndio',
                key: 'FIRE_INSURANCE_POLICY',
                required: false
              },
              {
                name: 'Comprovante de Pagamento (planilha)',
                key: 'PAYMENT_VOUCHER',
                required: false
              },
              {
                name: 'Declaração de débitos',
                key: 'DEBITS_SHEET',
                required: true
              },
              {
                name: 'Acordo de Confissão de Dívidas',
                key: 'DEBT_CONFESS_AGREEMENT',
                required: false
              },
              {
                name: 'Contrato de Locação',
                key: 'LOCATION_QUOTATION',
                required: true
              },
              {
                name: 'Planilha de indenização',
                key: 'INDEMNITY_WORKSHEET',
                required: false
              },
              {
                name: 'Planilha de acordo',
                key: 'ACCORD_WORKSHEET',
                required: false
              },
              {
                name: 'Água',
                key: 'WATER_BILL',
                required: false
              },
              {
                name: 'Luz',
                key: 'ENERGY_BILL',
                required: false
              },
              {
                name: 'Apólice Seguro Fiança',
                key: 'BAIL_INSURANCE_POLICY',
                required: false
              },
              {
                name: 'Boleto Devolutivo',
                key: 'RETURN_BILL',
                required: false
              },
              {
                name: 'Planilha de danos',
                key: 'DAMAGE_WORKSHEET',
                required: false
              },
              {
                name: 'Planilha de pintura',
                key: 'PAINTING_WORKSHEET',
                required: false
              },
              {
                name: 'Informativo de sinistro',
                key: 'CLAIM_INFORMATION',
                required: false
              },
              { name: 'Outros', key: 'OTHER', required: false }
            ];

        let requireds = fileIdentifiers.filter(fi => fi.required === true);
        values.claimFiles.forEach(
          file => (requireds = requireds.filter(c => c.key !== file.name))
        );
        // Also filter out existing files from requireds
        existingFiles.forEach(
          file => (requireds = requireds.filter(c => c.key !== file.option))
        );

        if (requireds.length > 0) {
          requireds.forEach(req => {
            warningNotification(
              'Ops',
              `Por favor, anexe um arquivo do tipo: ${req.name}`
            );
          });
          return;
        }
        try {
          setLoadingFiles(true);
          await submitFiles(values.claimFiles);
          setLoadingFiles(false);
        } catch (err) {
          console.error('[Upload Error]', err);
          const errorMessage = (err as any)?.message || 'Falha ao enviar os arquivos';
          dangerNotification('Erro no Upload', errorMessage);
          return;
        } finally {
          setLoadingFiles(false);
        }
        await submitClaimEstate(values);
      }
    }
  }

  async function handleSaveDraft(values: CreateClaimEstateInitialInitialValuesType) {
    // Skip validations
    // Set status to DRAFT
    const draftValues = { ...values };
    draftValues.claimEstate.status = ClaimEstatesStatusEnum.draft;

    setLoading(true);
    try {
      // Determine if create or update
      // Since we reuse registerId, we can probably check if it exists in DB or just try update if draftId was passed?
      // But createClaimEstate handles ID generation if not passed? No, we pass ID.
      // If we are "saving as draft", it might be the first time (Create) or updating an existing draft (Update).
      // Let's assume Create if it's new (no draftId passed initially), but subsequent saves could be updates.
      // However simple approach: createClaimEstate with DRAFT status. 
      // If the ID already exists, createClaim might fail if not handled? 
      // createClaimEstate calls POST. 
      // If draftId was passed, we should probably call udateClaimEstate?
      // Or if we already saved once? 

      // Actually, let's look at submitClaimEstate: it calls createClaimEstate always.
      // If "Resume Draft", we are in a Create Modal but with "pre-filled" data.
      // If we click "Salvar como Rascunho" again, we want to UPDATE.

      if (draftId && values.claimEstate.id) {
        // Update logic
        setLoadingFiles(true);
        await submitFiles(values.claimFiles);
        setLoadingFiles(false);
        await udateDraft(values);
      } else {
        // Create logic
        setLoadingFiles(true);
        await submitFiles(values.claimFiles);
        setLoadingFiles(false);
        await submitClaimEstate(draftValues, true);
      }
    } catch (err) {
      console.error('[Salvar Rascunho Error]', err);
      const errorMessage = extractApiErrorMessages(err, 'Falha ao salvar rascunho');
      dangerNotification('Erro ao Salvar Rascunho', errorMessage, 8000);
    } finally {
      setLoading(false);
      setLoadingFiles(false);
    }
  }

  async function udateDraft(values: CreateClaimEstateInitialInitialValuesType) {
    // Prepare payload similar to EditModal
    const cvFormatted = prepareValues(values).map((v: any) => ({
      ...v,
      claimEstateId: values.claimEstate.id
    }));

    // Limpar campos de relacionamento que são objetos e campos que não existem na entidade
    const {
      createdBy,
      insurer,
      estate,
      responsible,
      claimTenant: _claimTenant,
      claimProperty: _claimProperty,
      claimValues: _claimValues,
      policyId, // Não existe na entidade
      bondInsuranceHiredData, // Vamos mapear para bondInsuranceHiredDataId
      ...restClaimEstate
    } = values.claimEstate as any;

    // Mapear para o nome correto da coluna na entidade
    const bondInsuranceId = typeof bondInsuranceHiredData === 'object'
      ? bondInsuranceHiredData?.id
      : (bondInsuranceHiredData || policyId || null);

    const payload = {
      claimEstate: {
        ...restClaimEstate,
        insurerId: values?.claimEstate?.insurerId || null,
        bondInsuranceHiredDataId: bondInsuranceId,
        notificationEmails: Array.isArray(values.claimEstate.notificationEmails)
          ? values.claimEstate.notificationEmails.join(';')
          : values.claimEstate.notificationEmails
      },
      claimProperty: formatClaimProperty(values.claimProperty),
      claimTenant: values.claimTenant,
      claimValues: cvFormatted,
      userId: get('uid')
    };

    try {
      await udateClaimEstate(values.claimEstate.id!, payload as claimSubmitProps);
      successNotification('Sucesso', 'Rascunho atualizado com sucesso!');
      handleCloseModal();
      history.push('claim_estates');
    } catch (err) {
      console.error('[Atualizar Rascunho Error]', err);
      const errorMessage = extractApiErrorMessages(err, 'Erro ao atualizar rascunho');
      dangerNotification('Erro ao Atualizar Rascunho', errorMessage, 8000);
    }
  }

  function prepareValues(values: CreateClaimEstateInitialInitialValuesType) {
    const claimValues = values.claimValues.condominiumFee
      .concat(values.claimValues.energyBill)
      .concat(values.claimValues.gasBill)
      .concat(values.claimValues.paintingValue)
      .concat(values.claimValues.penalty)
      .concat(values.claimValues.propertyDamageValue)
      .concat(values.claimValues.rentValue)
      .concat(values.claimValues.taxesValue)
      .concat(values.claimValues.waterBill)
      .concat(values.claimValues.fireInsuranceBill);

    const cv: any = [];
    claimValues.forEach(e => {
      if (e.value) cv.push(e);
    });

    return cv.map((claimValue: ClaimValueFormikType) => {
      const format = { ...claimValue };
      format.dueDate = FormatDateYMD_UTC_IGNORE(new Date(claimValue.dueDate!));
      return {
        ...format,
        value: Number(format.value),
        valueType: format.valueType?.toUpperCase(),
        claimEstateId: values.claimEstate.id || registerId,
        paintingArea: format.paintingArea != null ? Number(format.paintingArea) : undefined,
        totalInstallments: format.totalInstallments != null ? Number(format.totalInstallments) : undefined,
        numberInstallment: format.numberInstallment != null ? Number(format.numberInstallment) : undefined
      };
    });
  }

  // Função para formatar claimProperty com deliveryKeysDate no formato YYYY-MM-DD
  function formatClaimProperty(claimProperty: any) {
    return {
      ...claimProperty,
      deliveryKeysDate: claimProperty.deliveryKeysDate
        ? FormatDateYMD_UTC_IGNORE(new Date(claimProperty.deliveryKeysDate))
        : undefined
    };
  }

  async function handleBackStep() {
    switch (stepOfHireModal) {
      case 'claim_estate_info': {
        handleCloseModal();
        return;
      }
      case 'claim_values_info': {
        setStepOfHireModal('claim_estate_info');
        return;
      }
      case 'document_attachment': {
        setStepOfHireModal('claim_values_info');
        return;
      }
    }
  }

  async function submitFiles(
    files: {
      file: File;
      name: string;
    }[]
  ) {
    const MAX_RETRIES = 3;
    const TIMEOUT_MS = 60000; // 60 seconds

    const fileToBlob = async (theFile: File) => {
      try {
        const arrayBuffer = await theFile.arrayBuffer();
        return new Blob([new Uint8Array(arrayBuffer)], {
          type: theFile.type
        });
      } catch (error) {
        const errorMessage = (error as Error)?.message || '';
        if (
          errorMessage.includes('could not be found') ||
          errorMessage.includes('NotFoundError') ||
          errorMessage.includes('NotReadableError')
        ) {
          throw new Error(
            `O arquivo "${theFile.name}" não está mais acessível. Por favor, remova-o e adicione novamente.`
          );
        }
        throw new Error(
          `Erro ao ler o arquivo "${theFile.name}": ${errorMessage || 'Erro desconhecido'}`
        );
      }
    };

    const uploadWithRetry = async (
      uploadURL: string,
      blob: Blob,
      fileName: string
    ): Promise<Response> => {
      let lastError: Error | null = null;

      for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

          const response = await fetch(uploadURL, {
            method: 'PUT',
            body: blob,
            signal: controller.signal
          });

          clearTimeout(timeoutId);

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }

          return response;
        } catch (error) {
          lastError = error as Error;

          if (attempt < MAX_RETRIES) {
            // Exponential backoff: 1s, 2s, 4s
            const waitTime = 1000 * Math.pow(2, attempt - 1);
            console.log(
              `[Upload] Tentativa ${attempt}/${MAX_RETRIES} falhou para "${fileName}". Aguardando ${waitTime}ms...`
            );
            await new Promise(resolve => setTimeout(resolve, waitTime));
          }
        }
      }

      throw new Error(
        `Falha ao enviar arquivo "${fileName}" após ${MAX_RETRIES} tentativas: ${lastError?.message || 'Erro desconhecido'}`
      );
    };

    const responses = [];
    const total = files.length;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let fileId: string | null = null;

      // Update progress state
      setUploadProgress({
        current: i + 1,
        total,
        fileName: file.file.name
      });

      try {
        await validateFileAccessibility(file.file);

        let response;
        let lastPreSignError: Error | null = null;
        let preSignSuccess = false;

        for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
          try {
            response = await postFileAndGetPreSignAxios({
              filename: sanitizeFilename(file.file.name),
              contentType: file.file.type,
              referencedTableName: 'CLAIM_ESTATES',
              referencedTableId: registerId,
              name: file.name
            });
            preSignSuccess = true;
            fileId = response.id; // Guardar ID para possível rollback
            break;
          } catch (error) {
            lastPreSignError = error as Error;
            if (attempt < MAX_RETRIES) {
              const waitTime = 1000 * Math.pow(2, attempt - 1);
              console.log(
                `[PreSign] Tentativa ${attempt}/${MAX_RETRIES} falhou para "${file.file.name}". Aguardando ${waitTime}ms...`
              );
              await new Promise(resolve => setTimeout(resolve, waitTime));
            }
          }
        }

        if (!preSignSuccess || !response) {
          throw new Error(
            `Falha ao obter link de upload para "${file.file.name}" após ${MAX_RETRIES} tentativas: ${lastPreSignError?.message || 'Erro desconhecido'}`
          );
        }

        const blob = await fileToBlob(file.file);

        await uploadWithRetry(response.uploadURL, blob, file.file.name);

        responses.push({ id: response.id, contextType: file.name });
      } catch (error) {
        // Se falhou após criar a entrada no banco, fazer rollback
        if (fileId) {
          try {
            console.log(`[Upload] Rollback: removendo entrada órfã ${fileId}`);
            await deleteFilesLinkAxios(fileId);
          } catch (deleteError) {
            console.error(`[Upload] Falha ao remover entrada órfã ${fileId}:`, deleteError);
          }
        }

        // Re-throw with file name context
        setUploadProgress(null);
        throw error;
      }
    }

    setUploadProgress(null);
    return responses;
  }

  async function submitClaimEstate(values: CreateClaimEstateInitialInitialValuesType, isDraft = false) {
    setLoading(true);
    if (values.claimProperty.deliveryKeysDate) {
      values.claimProperty.deliveryKeysDate = FormatDateYMD(
        new Date(values.claimProperty.deliveryKeysDate!)
      );
    }

    const userId = get('uid');
    values.claimEstate.id = registerId;
    values.claimEstate.createdBy = userId!;
    if (isDraft) {
      values.claimEstate.status = ClaimEstatesStatusEnum.draft;
    } else {
      values.claimEstate.status = ClaimEstatesStatusEnum.created;
    }
    values.claimValues.taxesValue = values.claimValues.taxesValue.map(c => ({
      ...c,
      totalInstallments: values.claimValues.taxesValue[0].totalInstallments
    }));
    values.claimValues.fireInsuranceBill = values.claimValues.fireInsuranceBill.map(
      c => ({
        ...c,
        totalInstallments: values.claimValues.fireInsuranceBill[0].totalInstallments,
        claimEstateId: registerId
      })
    );

    if (Array.isArray(values.claimEstate.notificationEmails)) {
      (values.claimEstate as any).notificationEmails = values.claimEstate.notificationEmails.join(';');
    }


    const assignId = (list: any[]) => list.map(i => ({ ...i, claimEstateId: registerId }));
    values.claimValues.condominiumFee = assignId(values.claimValues.condominiumFee);
    values.claimValues.energyBill = assignId(values.claimValues.energyBill);
    values.claimValues.gasBill = assignId(values.claimValues.gasBill);
    values.claimValues.paintingValue = assignId(values.claimValues.paintingValue);
    values.claimValues.penalty = assignId(values.claimValues.penalty);
    values.claimValues.propertyDamageValue = assignId(values.claimValues.propertyDamageValue);
    values.claimValues.rentValue = assignId(values.claimValues.rentValue);
    values.claimValues.waterBill = assignId(values.claimValues.waterBill);
    // taxes and fire already done above in original code, but repeated assignment safe
    values.claimValues.taxesValue = assignId(values.claimValues.taxesValue);
    values.claimValues.fireInsuranceBill = assignId(values.claimValues.fireInsuranceBill);

    try {
      if (draftId && !isDraft) {
        const claimValuesArray = prepareValues(values).map((v: any) => ({
          ...v,
          claimEstateId: registerId
        }));

        const {
          createdBy,
          insurer,
          estate,
          responsible,
          claimTenant: _claimTenant,
          claimProperty: _claimProperty,
          claimValues: _claimValues,
          policyId, // Não existe na entidade - usado apenas no DTO
          bondInsuranceHiredData, // Vamos mapear para bondInsuranceHiredDataId
          ...restClaimEstate
        } = values.claimEstate as any;

        // Mapear bondInsuranceHiredData para bondInsuranceHiredDataId (nome correto da coluna na entidade)
        const bondInsuranceId = typeof bondInsuranceHiredData === 'object'
          ? bondInsuranceHiredData?.id
          : (bondInsuranceHiredData || policyId || null);

        const cleanClaimEstate = {
          ...restClaimEstate,
          bondInsuranceHiredDataId: bondInsuranceId,
          notificationEmails: Array.isArray(restClaimEstate.notificationEmails)
            ? restClaimEstate.notificationEmails.join(';')
            : restClaimEstate.notificationEmails
        };

        const updatePayload = {
          claimEstate: cleanClaimEstate,
          claimProperty: formatClaimProperty(values.claimProperty),
          claimTenant: values.claimTenant,
          claimValues: claimValuesArray,
          userId: userId
        };

        await udateClaimEstate(registerId, updatePayload as any);

      } else {
        const {
          createdBy: _createdBy,
          insurer: _insurer,
          estate: _estate,
          responsible: _responsible,
          claimTenant: _ct,
          claimProperty: _cp,
          claimValues: _cv,
          bondInsuranceHiredData: _bihd, // Remover objeto, usar policyId
          ...restCreateClaimEstate
        } = values.claimEstate as any;

        // Para criação, o backend espera policyId no DTO (não bondInsuranceHiredDataId)
        const claimEstateAny = values.claimEstate as any;
        const policyIdValue = typeof claimEstateAny.bondInsuranceHiredData === 'object'
          ? claimEstateAny.bondInsuranceHiredData?.id
          : (claimEstateAny.policyId || claimEstateAny.bondInsuranceHiredData || null);

        const cleanCreateClaimEstate = {
          ...restCreateClaimEstate,
          policyId: policyIdValue,
          notificationEmails: Array.isArray(restCreateClaimEstate.notificationEmails)
            ? restCreateClaimEstate.notificationEmails.join(';')
            : restCreateClaimEstate.notificationEmails
        };

        const createPayload = {
          claimEstate: cleanCreateClaimEstate,
          claimProperty: formatClaimProperty(values.claimProperty),
          claimTenant: values.claimTenant,
          claimValues: prepareValues(values),
          userId: userId
        };
        await createClaimEstate(createPayload as any);
      }

      successNotification('Sucesso', 'Solicitação de abertura de sinistro realizada com sucesso!');
      handleCloseModal();
      history.push('claim_estates');
    } catch (err) {
      console.error('[Criar Sinistro Error]', err);
      const errorMessage = extractApiErrorMessages(err, 'Erro ao criar sinistro');
      dangerNotification('Erro ao Criar Sinistro', errorMessage, 8000);
    }
  }

  const ModalContent = ({ children, values }: ModalContentType) => (
    <>
      <Modal.Content scrolling>
        <Dimmer active={loadingFiles}>
          <Loader>
            {uploadProgress ? (
              <div style={{ textAlign: 'center' }}>
                <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
                  Enviando documentos ({uploadProgress.current} de {uploadProgress.total})
                </div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>
                  {uploadProgress.fileName}
                </div>
              </div>
            ) : (
              'Enviando documentos...'
            )}
          </Loader>
        </Dimmer>
        <Dimmer active={loading}>
          <Loader indeterminate> Comunicando solicitação... </Loader>
        </Dimmer>

        <div style={{ width: '100%' }}>
          <Step.Group widths={8}>
            <StepWrapper
              active={stepOfHireModal === 'claim_estate_info'}
              title="Informações Básicas"
              description="Informações sobre imóvel e locatário"
              icon={{ color: 'grey', name: 'home' }}
            />
            <StepWrapper
              active={stepOfHireModal === 'claim_values_info'}
              title="Sobre Valores"
              description="Datas de vencimento e valores devidos;"
              icon={{ color: 'grey', name: 'dollar sign' }}
            />

            <StepWrapper
              active={stepOfHireModal === 'document_attachment'}
              title="Documentos"
              description="Anexo dos documentos essenciais"
              icon={{ color: 'grey', name: 'upload' }}
            />
          </Step.Group>
        </div>

        {children}
      </Modal.Content>
      <Modal.Actions style={{ display: 'flex', justifyContent: 'space-between' }}>
        {stepOfHireModal === 'document_attachment' ? (
          <Button
            color="grey"
            onClick={() => handleSaveDraft(values)}
            style={{ marginRight: 'auto' }}
          >
            <Icon name="save" /> Salvar como Rascunho
          </Button>
        ) : <div />}
        <div style={{ display: 'flex' }}>
          <Button color="red" onClick={() => handleBackStep()}>
            <Icon name="remove" />
            {stepOfHireModal === 'claim_estate_info' ? 'Sair' : 'Voltar'}
          </Button>
          <Button color="green" onClick={() => handleNextStep(values)}>
            <Icon name="checkmark" />{' '}
            {stepOfHireModal === 'document_attachment' ? (draftId ? 'Atualizar e Solicitar' : 'Solicitar') : 'Próximo'}
          </Button>
        </div>
      </Modal.Actions>
    </>
  );

  return (
    <div>
      <Modal
        style={{ height: 'auto', width: '70vw', zIndex: 10 }}
        closeIcon
        open={openHireProposalModal}
        trigger={
          !onlyModal ? (
            <Button icon="hotjar" type="button">
              Novo Sinistro
            </Button>
          ) : (
            <></>
          )
        }
        onOpen={() => handleOpenModal()}
        onClose={() => handleCloseModal()}
      >
        <Header style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Icon name={'file alternate outline'} /> Abertura de Sinistro
          </div>

          <ModalInstructions
            openModal={openModal}
            toggleClose={toggleClose}
            toggleOpen={toggleOpen}
          />
        </Header>

        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={() => true}
          onSubmit={() => true}
        >
          {innerValues => {
            switch (stepOfHireModal) {
              case 'initial_verifications':
                return (
                  <InitialVerifications
                    {...innerValues}
                    onNext={handleInitialVerificationsNext}
                  />
                );
              case 'claim_estate_info':
                return (
                  <ModalContent
                    values={innerValues.values}
                    children={
                      <ClaimEstateInfoStep
                        {...innerValues}
                        estates={estates}
                        insurers={insurers}
                        policy={selectedPolicy || props.policy}
                        availableBrokersAndEstates={props.availableBrokersAndEstates}
                        claimAlread={claimAlread}
                        setClaimAlread={handleClaimAlread}
                        onCloseModal={handleCloseModal}
                      />
                    }
                  />
                );
              case 'claim_values_info':
                return (
                  <ModalContent
                    values={innerValues.values}
                    children={<ClaimValuesStep {...innerValues} />}
                  />
                );
              case 'document_attachment':
                return (
                  <ModalContent
                    values={innerValues.values}
                    children={
                      <DocumentsComponent
                        fileIdentifiers={getFileIdentifiers(innerValues)}
                        {...innerValues}
                        insurers={insurers}
                        existingFiles={existingFiles}
                        onDeleteExisting={handleDeleteExistingFile}
                      />
                    }
                  />
                );
            }
          }}
        </Formik>
      </Modal>
    </div>
  );
};

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

export default connect(mapState, mapDispatch)(CreateClaimEstateModal);
